import React from 'react';

export default ({additionalClassName = ''}): React.ReactElement<HTMLDivElement> => (
        <div className={`loading ${additionalClassName}`}/>
);
